export const formatAgendaDate = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getAgendaDayRange = (dateStr) => {
  const day = dateStr ? String(dateStr).slice(0, 10) : formatAgendaDate(new Date());
  return { from: day, to: day };
};

export const getAgendaCalendarRange = (
  anchorDate = new Date(),
  daysBefore = 7,
  daysAfter = 21,
) => {
  const anchor = anchorDate instanceof Date ? anchorDate : new Date(anchorDate);
  const start = new Date(anchor);
  start.setDate(start.getDate() - daysBefore);
  const end = new Date(anchor);
  end.setDate(end.getDate() + daysAfter);
  return { from: formatAgendaDate(start), to: formatAgendaDate(end) };
};

export const buildAgendaQuery = (from, to) => `?from=${from}&to=${to}`;

/** Rango visible del calendario (día o semana laboral). */
export const getAgendaViewRange = (date, view = 'work_week') => {
  const anchor = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(anchor.getTime())) {
    return getAgendaCalendarRange(new Date());
  }

  if (view === 'day') {
    const day = formatAgendaDate(anchor);
    return { from: day, to: day };
  }

  const dayIndex = anchor.getDay();
  const mondayOffset = dayIndex === 0 ? -6 : 1 - dayIndex;
  const start = new Date(anchor);
  start.setDate(anchor.getDate() + mondayOffset);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return { from: formatAgendaDate(start), to: formatAgendaDate(end) };
};
